
import { Avatar, Stack, Box } from '@mui/material'
import React from 'react'
import NotificationsIcon from '@mui/icons-material/Notifications';
import SettingsIcon from '@mui/icons-material/Settings';
import LanguageIcon from '@mui/icons-material/Language';
function Menu() {
    const cn = {
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
        alignItems: "center",
        gap: 1,
    }
    return (
        <Stack sx={{ backgroundColor: "#FFF", minHeight: "90vh" }} justifyContent={"space-around"}>
            <Box sx={cn} >
                <NotificationsIcon />
            </Box>
            <Box sx={{ ...cn, alignSelf: "end" }} >
                <LanguageIcon />
                <SettingsIcon />
            </Box>
        </Stack>
    )
}

export default Menu